import Note from '@/models/Note'
import Paginator from '@/models/Paginator'
import { note as backend } from '@/api'
import { common as commonBacked } from '@/api'

export default {

  namespaced: true,

  state: {
    note: new Note,
    notes: new Paginator,
    note_list: []
  },

  mutations: {
    setNote: (state, payload) => {
      state.note = (payload.id) ? payload : new Note
    },
    setNotes: (state, payload) => state.notes = payload,
    setNoteList: (state, payload) => state.note_list = payload,
    clear: (state) => state.note = new Note,
    content: (state, payload) => state.note.content = payload,
    title: (state, payload) => state.note.title = payload,
    toggleActive: (state) => state.note.active = !state.note.active,
    pushNote: (state, payload) => state.notes.data.push(payload),
    removeNote: (state, payload) => {
      let index = state.notes.data.indexOf(payload)
      state.notes.data.splice(index, 1)
    },
  },

  actions: {
    save: ({state, commit}) => new Promise((resolve, reject) => {
      if(state.note.id) {
        backend.update(state.note, ({data}) => {
          resolve(data)
        }, error => reject(error))
      } else {
        backend.store(state.note, ({data}) => {
          commit('setNote', data)
          resolve(data)
        }, error => reject(error))
      }
    }),
    loadNotes: ({commit}, path) => new Promise((resolve, reject) => {
      commonBacked.loadPath(path, ({data}) => {
        commit('setNotes', data)
        resolve()
      }, error => reject(error))
    }),
    loadList: ({commit}) => new Promise((resolve, reject) => {
      backend.list(({data}) => {
        commit('setNoteList', data)
        resolve()
      }, error => reject(error))
    }),
    load: ({commit}, noteId) => new Promise((resolve, reject) => {
      backend.load(noteId, ({data}) => {
        commit('setNote', data)
        resolve()
      }, error => reject(error))
    }),
    loadActiveNote: ({commit}) => new Promise((resolve, reject) => {
      backend.loadActiveNote(({data}) => {
        commit('setNote', data)
        resolve()
      }, error => reject(error))
    }),
    pinNote: ({commit}, noteId) => new Promise((resolve, reject) => {
      backend.pinNote(noteId, ({data}) => {
        commit('setNote', data)
        resolve()
      }, error => reject(error))
    }),
    trashNote: ({}, noteId) => new Promise((resolve, reject) => {
      backend.trashNote(noteId, () => {
        resolve()
      }, error => reject(error))
    })
  },

  getters: {
    notes: state => state.notes,
    noteList: state => state.note_list,
    note: state => state.note,
  }

}